// extracted by mini-css-extract-plugin
export default {"Cart-table":"ProductCartTable_Cart-table__SzYHL"};